import { Button } from '@/shared/ui/Button';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import React from 'react';
import type { ContainerProps } from '../Card/Container';
import Container from '../Card/Container';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
import styles from './Modal.module.scss';

interface ModalProps extends ContainerProps {
	backgroundImage?: string;
	className?: string;
	disabled?: boolean;
	dismissOnClick?: () => void;
	externalButton?: string;
	externalButtonOnClick?: () => void;
	isExternalButtonDisabled?: boolean;
	onClick?: () => void;
	textButton?: string;
}

const Modal = ({
	textButton,
	externalButton,
	children,
	isLight,
	className,
	isExternalButtonDisabled,
	dismissOnClick,
	externalButtonOnClick,
	onClick,
	disabled,
	backgroundImage,
}: ModalProps) => {
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.3 }}
			className={clsx(styles.modal, className)}
		>
			<Container isLight={isLight} backgroundImage={backgroundImage}>
				{dismissOnClick ? (
					<button className={styles.dismissButton} onClick={dismissOnClick}>
						<Icon name='sprite/dismiss-icon' color='white' size={32} />
					</button>
				) : null}
				{children}
			</Container>
			{textButton ? (
				<div className={styles.buttonWrapper}>
					<Button disabled={disabled} onClick={onClick}>
						<Typography color='white' variant='title3' variantS='headline2'>
							{textButton}
						</Typography>
					</Button>
					{externalButton ? (
						<button
							className={styles.externalButton}
							disabled={isExternalButtonDisabled}
							onClick={externalButtonOnClick}
						>
							<Typography variant='body2' color='white'>
								{externalButton}
							</Typography>
						</button>
					) : null}
				</div>
			) : null}
		</motion.div>
	);
};

export default Modal;
